import SearchPage from '../../../src/containers/SearchPage';
import { createInitialState } from '../../../src/containers/SearchPage';
import { formatSearchLocationParam } from '../../../src/data/searchHelper';
import {createRequestConfig, STATS_URL, STATS_URL_INTERNAL} from '../../../src/DataProviders/SearchPageListingsProvider'
import _ from 'lodash';
import axios from 'axios';
import {API_KEYS, URL_COMPONENTS} from '../../../src/__constants__';
import { isProfessionalTypeInUrlCorrect, redirect } from '../../../src/utils/urlHelpers';

const Search = (props) => {
    return (
        <SearchPage key={`searchPage${new Date().toISOString()}`} initialProfessionals={props.initialProfessionals} showMe={props.showMe} initialFirms={props.initialFirms}/>
    );
};

// This gets called on every request
export async function getServerSideProps(props) {
    const { params, query } = props;

    if ( !isProfessionalTypeInUrlCorrect(URL_COMPONENTS, params.type) ) return redirect()

    const initial = createInitialState(`/${params.type}/${params.location}`)
    let defaultParams = initial.defaultParams
    defaultParams.limit = 5;
    defaultParams.sort_by = 'sigmoid';
    const latitude = _.get(defaultParams, 'latitude', null);
    const longitude = _.get(defaultParams, 'longitude', null);

    if (latitude && longitude) {
        defaultParams = _.omit(defaultParams, 'location');
    } else {
        defaultParams.location = formatSearchLocationParam(defaultParams.location);
    }

    const ssProps = { location: params.location, type: params.type };

    if (query.view && query.view === 'firms') {
        const resFirms = await axios.get(`${API_KEYS.API_URL}/v2/public/search/firm-location?query=${defaultParams.location}&offset=0`);
        ssProps.initialFirms = resFirms.data;
    } else {
        const res = await axios.get(STATS_URL_INTERNAL, createRequestConfig(defaultParams))
        const data = _.get(res, 'data', null);
        ssProps.initialProfessionals = data;
    }

    if (query.view) {
        ssProps.showMe = query.view;
    }

    return { props: ssProps }
}

export default Search;
